var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    fill: "#E46666",
    fillOpacity: 0.14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    stroke: "#CD0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 8.14706H19.6666M11.3333 16.9706V11.6765M14.6666 16.9706V11.6765M16.3333 20.5H9.66659C8.74611 20.5 7.99992 19.7099 7.99992 18.7353V9.02941C7.99992 8.5421 8.37301 8.14706 8.83325 8.14706H17.1666C17.6268 8.14706 17.9999 8.5421 17.9999 9.02941V18.7353C17.9999 19.7099 17.2537 20.5 16.3333 20.5ZM11.3333 8.14706H14.6666C15.1268 8.14706 15.4999 7.75202 15.4999 7.26471V6.38235C15.4999 5.89504 15.1268 5.5 14.6666 5.5H11.3333C10.873 5.5 10.4999 5.89504 10.4999 6.38235V7.26471C10.4999 7.75202 10.873 8.14706 11.3333 8.14706Z",
    stroke: "#CD0000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelIcon);
export default __webpack_public_path__ + "static/media/DelIcon.319dd47cffcc24834c17fe34b655d108.svg";
export { ForwardRef as ReactComponent };